module.exports = {"623027100":"拉卜楞镇","623027101":"王格尔塘镇","623027102":"阿木去乎镇","623027200":"桑科乡","623027201":"甘加乡","623027202":"达麦乡","623027203":"麻当乡","623027204":"曲奥乡","623027205":"唐尕昂乡","623027206":"扎油乡","623027207":"博拉乡","623027208":"吉仓乡","623027209":"科才乡","623027400":"夏河县种子站","623027401":"夏河县机饲总站","623027402":"夏河县桑科种羊场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623027.json
// module id = 2765
// module chunks = 0